<template>
  <section :id="anchorId" class="summary-panel">
    <header class="summary-panel-header">
      <h5 class="summary-panel-title">{{ title }}</h5>
      <span
        v-for="badge in badges"
        :key="badge.label"
        class="summary-panel-badge"
        :class="{ 'summary-panel-badge-warn': badge.warn }"
      >{{ badge.label }}</span>
    </header>
    <slot />
  </section>
</template>

<script>
export default {
  name: 'SummaryPanel',
  props: {
    title: {
      type: String,
      required: true,
    },
    badges: {
      type: Array,
      default: () => [],
    },
    anchorId: {
      type: String,
      default: null,
    },
  },
};
</script>

<style scoped>
.summary-panel {
  background: var(--mz-surface);
  border: 1px solid var(--mz-border);
  border-radius: 8px;
  padding: 10px 12px;
  min-width: 0;
  /* nav HP sticky 70px + pill */
  scroll-margin-top: 124px;
}

.summary-panel-header {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 8px;
  margin-bottom: 8px;
}

.summary-panel-title {
  font-size: 16.8px;
  font-weight: 600;
  color: var(--mz-text);
  margin: 0;
}

.summary-panel-badge {
  font-size: var(--mz-fs-sm);
  font-weight: 600;
  line-height: 1.4;
  padding: 1px 8px;
  border-radius: 10px;
  background: #fff3cd;
  color: #856404;
}

.summary-panel-badge-warn {
  background: #f8d7da;
  color: #721c24;
}
</style>
